import SectionHeading from "./SectionHeading";
import { editorPicks } from "@/mocks/doujinshi";

function formatViews(n: number) {
  return n >= 10000 ? `${(n / 10000).toFixed(1)}万` : `${n}`;
}

export default function EditorPicks() {
  return (
    <section id="picks" className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionHeading
        eyebrow="编辑精选"
        title="本周编辑专栏 · 私藏推荐"
        desc="由编辑团队从本期上新中挑出的宝藏同人志，每一部都值得慢慢翻阅与收藏。"
      />

      <div className="-mx-4 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 pb-4 md:-mx-6 md:px-6">
        {editorPicks.map((p) => (
          <a
            key={p.id}
            href="#about"
            className="group flex w-[240px] shrink-0 snap-start flex-col overflow-hidden rounded-lg border border-background-200/70 bg-background-50 transition-all hover:-translate-y-1 hover:border-accent-200 sm:w-[260px]"
          >
            <div className="relative aspect-[4/5] w-full overflow-hidden">
              <img
                src={p.cover}
                alt={`编辑精选：${p.title} 同人志作品封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-[11px] text-background-50">
                <i className="ri-star-fill"></i>
                编辑精选
              </span>
            </div>
            <div className="flex flex-1 flex-col p-4">
              <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-0.5 text-xs text-foreground-500">
                {p.circle} · {p.format}
              </p>
              <div className="mt-2 flex flex-wrap gap-1.5">
                {p.tags.map((tag) => (
                  <span key={tag} className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] text-accent-900">
                    {tag}
                  </span>
                ))}
              </div>
              <p className="mt-3 line-clamp-3 flex-1 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
              <div className="mt-3 flex items-center justify-between border-t border-background-200 pt-3 text-[11px] text-foreground-500">
                <span className="inline-flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {formatViews(p.views)}
                </span>
                <span className="inline-flex items-center gap-1 text-accent-700">
                  立即翻阅 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          </a>
        ))}
      </div>
    </section>
  );
}